window.addEventListener('scroll', () => {
  const header = document.querySelector('#header');
  const section_1 = document.querySelector('#shopify-section-template--25337814253901__mosaic_grid_2_column_Hx7J8C')
  const section_2 = document.querySelector('#shopify-section-template--25337814253901__image_with_text_hUwy9Q')
  const section_2_text = document.querySelector('#shopify-section-template--25337814253901__image_with_text_hUwy9Q .image-with-text__text-container')
  const footer = document.querySelector('#shopify-section-template--25337814253901__text_columns_with_images_8eKxib');
  const scrollTop = window.scrollY;

  if (scrollTop >= section_1.offsetTop) {
    header.style = "filter: invert(1);"
  }else{
     header.style = "filter: invert(0);"
  }

  if (scrollTop >= footer.offsetTop) {
    header.style = "filter: invert(0);"
  }

  if(window.innerWidth < 580){
    if (scrollTop >= (section_2.offsetTop +section_2_text.offsetTop)) {
        header.style = "filter: invert(0);"
    }
  }
});